<template>
    <div class="loading-bar-container">
        <h6>Loading... </h6>
      <div class="loading-bar"></div>
    </div>
  </template>
  
  <script>
  export default {
    name: 'LoadingBar'
  };
  </script>
  
  <style scoped>
  /* Container for the loading bar */
  .loading-bar-container {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    height: 100vh;
    background-color: var(--bg-primary);
  }
  
  .loading-bar-container h6 {
    color: var(--text-primary);
    margin-bottom: 20px;
  }
  
  /* Styling for the loading bar */
  .loading-bar {
    width: 150px;
    height: 12px;
    background-color: #03e43b;
    position: relative;
    overflow: hidden;
    border-radius: 4px;
  }
  
  /* Animation for the loading bar */
  .loading-bar::before {
    content: '';
    position: absolute;
    top: 0;
    left: -100%;
    width: 100%;
    height: 100%;
    background-color: rgba(255, 255, 255, 0.3);
    animation: loading 1.5s linear infinite;
  }
  
  /* Keyframes for the loading effect */
  @keyframes loading {
    0% {
      left: -100%;
    }
    100% {
      left: 100%;
    }
  }
  </style>
  